/**
 * Breadcrumb Middle Ellipsis
 * Truncates long breadcrumb text in the middle: "How many ... health?"
 */

(function($) {
  'use strict';

  function applyMiddleEllipsis() {
    // Only apply on mobile
    if ($(window).width() >= 768) {
      return;
    }

    $('.breadcrumb-list li:last-child span').each(function() {
      var $span = $(this);
      var fullText = $span.text().trim();
      
      // Skip if already processed or empty
      if ($span.data('original-text') || !fullText) {
        return;
      }
      
      // Store original text
      $span.data('original-text', fullText);
      
      // Calculate max length based on container width
      var containerWidth = $span.parent().width();
      var charWidth = 8; // Approximate char width in pixels
      var maxChars = Math.floor(containerWidth / charWidth);
      
      // If text is short enough, don't truncate
      if (fullText.length <= maxChars) {
        return;
      }
      
      // Calculate how many chars to show from start and end
      var charsToShow = maxChars - 5; // Leave room for " ... "
      var frontChars = Math.ceil(charsToShow * 0.4); // 40% at start
      var backChars = Math.floor(charsToShow * 0.6); // 60% at end
      
      // Create truncated text with middle ellipsis
      var truncated = fullText.substring(0, frontChars) + 
                      ' ... ' + 
                      fullText.substring(fullText.length - backChars);
      
      $span.text(truncated);
      
      // Add title attribute for full text on hover
      $span.attr('title', fullText);
    });
  }

  // Apply on page load
  $(document).ready(function() {
    applyMiddleEllipsis();
  });

  // Reapply on window resize (debounced)
  var resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Reset all breadcrumbs first
      $('.breadcrumb-list li:last-child span').each(function() {
        var $span = $(this);
        var originalText = $span.data('original-text');
        if (originalText) {
          $span.text(originalText);
          $span.removeData('original-text');
          $span.removeAttr('title');
        }
      });
      
      // Reapply ellipsis
      applyMiddleEllipsis();
    }, 250);
  });

})(jQuery);

